export default function SidebarButton({ icon: Icon, active = false, onClick, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
      title={label}
      className={`flex items-center justify-center shrink-0 w-12 h-12 rounded-2xl border-none cursor-pointer transition-colors duration-200 ease-out active:scale-[0.96] ${
        active
          ? 'bg-white/[0.1]'
          : 'bg-transparent [@media(hover:hover)]:hover:bg-white/[0.05]'
      }`}
    >
      <Icon
        size={21}
        color={active ? '#ffffff' : 'rgba(255, 255, 255, 0.4)'}
      />
    </button>
  );
}
